import { FormattedText } from "@tm/ui-widgets/components";

export const DisclaimerSection = ({
  disclaimer,
}: {
  disclaimer?: { info?: string };
}) => {
  const info = disclaimer?.info;
  if (!info) return null;

  return (
    <div
      style={{
        borderRadius: 16,
        padding: "12px 16px",
        fontSize: 12,
        lineHeight: "16px",
        color: "#000000",
        overflow: "hidden",
      }}
    >
      <FormattedText value={info} />
    </div>
  );
};
